import { useState } from 'react';
import { THEME_MODE_KEY, resolveTheme, applyTheme, type ThemeMode } from '@/app/ThemeProvider';
import styles from './ThemeToggle.module.css';

export function ThemeToggle() {
  const [mode, setMode] = useState<ThemeMode>(
    () => (localStorage.getItem(THEME_MODE_KEY) as ThemeMode) || 'system',
  );

  const resolved = resolveTheme(mode);

  function toggle() {
    const next: ThemeMode = resolved === 'dark' ? 'light' : 'dark';
    localStorage.setItem(THEME_MODE_KEY, next);
    applyTheme(next);
    setMode(next);
  }

  return (
    <button
      className={styles.btn}
      onClick={toggle}
      aria-label={resolved === 'dark' ? 'Включить светлую тему' : 'Включить тёмную тему'}
      aria-pressed={resolved === 'dark'}
    >
      <span className={styles.circle} aria-hidden>
        {resolved === 'dark' ? '☾' : '☀'}
      </span>
    </button>
  );
}
